<template>
  <div class="flex">
    <feather-icon class="mr-4" :icon="feature.icon" :svgClasses="svgClasses" />

    <div>
      <span class="font-bold text-xl">{{feature.name}}</span>
      <div>{{feature.description}}</div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['feature', 'bigIcon'],
  computed: {
    svgClasses () {
      if (this.bigIcon && this.$store.getters.isLargeScreen) {
        return 'h-8 w-8 stroke-current text-primary'
      } else {
        return 'h-6 w-6 stroke-current text-primary'
      }
    }
  }
}

</script>
